import 'isomorphic-unfetch';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import ErrorBoundary from './ErrorBoundary';
import StyledGlobal from './StyledGlobal';
const AppBase = _ref => {
  let {
    children,
    theme
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(StyledGlobal, {
    theme: theme
  }), children));
};
export default AppBase;